<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Detalle cliente:</h4>
            </div>
         </div>
      </div>
      <div class="row">
         <details-widget></details-widget>
         <sales-widget></sales-widget>
      </div>
      <div class="row">
         <tabs-widget></tabs-widget>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Main"
   import DetailsWidget from '@/components/widgets/customers/details.vue'
   import SalesWidget from '@/components/widgets/customers/sales.vue'
   import TabsWidget from '@/components/widgets/customers/tabs.vue'

   export default {
      name: 'Customer-Detail',
      components: {
         Layout, DetailsWidget, SalesWidget, TabsWidget
      }
   }
</script>
